export default function environmentsApis($apiInstance, $store) {
    return {
        // 환경 설정 목록 조회
        getEnvConfigs: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            
            // params 객체를 query string으로 변환
            const queryParams = new URLSearchParams();
            Object.keys(params).forEach(key => {
                if (params[key] !== null && params[key] !== undefined) {
                    queryParams.append(key, params[key]);
                }
            });

            return $apiInstance.get(`/env-configs?${queryParams.toString()}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // 환경 설정 단건 조회
        getEnvConfig: async (configKey, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.get(`/env-configs/${configKey}`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // 환경 설정 다건 등록
        createEnvConfigBulk: async (configs, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.post('/env-configs/bulk', { configs })
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // 환경 설정 단건 등록
        createEnvConfig: async (data, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.post('/env-configs', data)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // 환경 설정 수정
        updateEnvConfig: async (configKey, data, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.patch(`/env-configs/${configKey}`, data)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },

        // 환경 설정 삭제 (소프트 딜리트)
        deleteEnvConfig: async (configKey, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.delete(`/env-configs/${configKey}/delete`)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        }
    }
}
